import { useTranslation } from 'react-i18next'
import { useSearchParams } from 'react-router-dom'
import CreateAssetForm from '../forms/CreateAsset'
import SubHeaders from '@/components/Headers/SubHeaders'

const CreateAsset = () => {
    const { t } = useTranslation('asset')
    const [searchParams] = useSearchParams()
    const isUpdateMode = searchParams.get('mode') === 'update'

    return (
        <div>
            <SubHeaders
                breadcrumbs={[
                    {
                        title: t('assets'),
                        path: '/assets',
                    },
                    {
                        title: isUpdateMode
                            ? t('form.updateAsset')
                            : t('create'),
                        path: '',
                    },
                ]}
            />
            <CreateAssetForm isUpdateMode={isUpdateMode} />
        </div>
    )
}

export default CreateAsset
